import { render } from "./tips_modal.vue?vue&type=template&id=52e99744"
import script from "./tips_modal.vue?vue&type=script&lang=ts"
export * from "./tips_modal.vue?vue&type=script&lang=ts"

import "./tips_modal.vue?vue&type=style&index=0&id=52e99744&lang=css"
script.render = render

export default script